<template>
  <div class="pt-10">
    <div class="row">
      <div class="col-11 mt-5 pt-5 text-left">
        <h5 class="text-danger">
          <strong> EVENTOS </strong>
        </h5>
      </div>
      <div class="col-1 mt-5 pt-5 text-left">
        <button
          @click="openModal()"
          data-bs-toggle="modal"
          data-bs-target="#modalPromo"
          class="btn btn-danger btn-block"
        >
          <i class="fa fa-plus m-0 p-0" aria-hidden="true"></i>
        </button>
      </div>
    </div>

    <!-- Lista de bonos -->

    <div class="row mt-4">
      <div class="col-12">
        <div class="table-responsive">
          <table class="table table-striped table-sm">
            <thead>
              <tr>
                <th scope="col" style="text-align: left">Fecha inicial</th>
                <th scope="col" style="text-align: left">Fecha final</th>
                <th scope="col" style="text-align: left">Evento</th>
                <th scope="col" style="text-align: left">Nombre producto</th>
                <th scope="col" style="text-align: left">Cantidad total</th>
                <th scope="col" style="text-align: left">Disponibilidad</th>
                <th scope="col" style="text-align: left">Estado</th>
                <th scope="col" style="text-align: left">Acciones</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, i) in items" :key="'d' + `item-${i}`">
                <td style="text-align: left">
                  {{ item.init_date }}
                </td>
                <td style="text-align: left">
                  {{ item.fin_date }}
                </td>
                <td style="text-align: left">
                  {{ item.event_name }}
                </td>
                <td style="text-align: left">
                  {{ item.product_name }}
                </td>
                <td style="text-align: left">
                  <h5>
                    <span class="badge badge-pill badge-danger">
                      {{ item.quantity }}
                    </span>
                  </h5>
                </td>
                <td style="text-align: left">
                  <h5>
                    <span class="badge badge-pill badge-success">
                      {{ item.availability }}
                    </span>
                  </h5>
                </td>
                <td style="text-align: left">
                  {{ item.status.name }}
                </td>
                <td style="text-align: left">
                  <div class="btn-group" role="group">
                    <button
                      data-toggle="tooltip"
                      data-placement="bottom"
                      class="btn btn-info mt-0 pt-0 mb-0 pb-0 ml-2 pl-2 mr-2 pr-2"
                      title="Editar bono promocional"
                      @click="openModalEdit(item)"
                    >
                      <i class="fa fa-pencil m-0 p-0" aria-hidden="true"></i>
                    </button>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>

    <div class="row">
      <div
        class="col-12 col-md-3 col-lg-3 col-xl-3 col-sm-12 mt-2  "
        style="text-align: initial;"
      >
        <label class="text-p mt-2">
          Página {{ currentPage }} de {{ totalPages }}
          <b class="text-danger"> | </b> total: {{ totaItems }}
        </label>
      </div>
      <div class="col-12 col-md-9 col-lg-9 col-xl-9 col-sm-12 mt-2 ">
        <div class="float-right">
          <v-pagination
            total-visible="2"
            v-model="currentPage"
            :page-count="totalPages"
            :classes="bootstrapPaginationClasses"
          ></v-pagination>
        </div>
      </div>
    </div>

    <!-- fin de la lista de bonos -->

    <!-- Modal Nueva bono -->
    <div
      class="modal fade"
      id="modalPromo"
      tabindex="-1"
      role="dialog"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered border-danger">
        <div class="modal-content modal-promotional">
          <div class="modal-body">
            <button
              type="button"
              data-dismiss="modal"
              aria-label="Close"
              class="close"
            >
              <i class="fa fa-times-circle text-danger" aria-hidden="true"></i>
            </button>
            <div class="mt-3 row justify-content-center">
              <div class="col-12 mb-3">
                <label style="color: #616161;">
                  <b> NUEVO EVENTO</b> </label
                ><br />
              </div>

              <!-- Estructura del formulario -->

              <div class="col-12 m-0 p-0">
                <div class="form-group">
                  <div class="row" style="text-align: left">
                    <div class="col-12  m-0 p-0">
                      <div class="row">
                        <div class="col-12">
                          <div class="form-group">
                            <label
                              class="ml-1"
                              for="state"
                              style="color: #616161; font-size: 14px"
                              ><b>Nombre del producto *</b>
                            </label>
                            <input
                              :class="{ 'is-danger': errors.productName }"
                              type="text"
                              v-model="form.productName"
                              class="form-control"
                            />
                          </div>
                          <span
                            v-if="errors.productName"
                            class="text-danger float-left small error-danger mb-2"
                            >{{ errors.productName }}</span
                          >
                        </div>

                        <div class="col-12">
                          <div class="form-group">
                            <label
                              class="ml-1"
                              for="state"
                              style="color: #616161; font-size: 14px"
                              ><b>Nombre del evento *</b>
                            </label>
                            <input
                              :class="{ 'is-danger': errors.eventName }"
                              type="text"
                              v-model="form.eventName"
                              class="form-control"
                            />
                          </div>
                          <span
                            v-if="errors.eventName"
                            class="text-danger float-left small error-danger mb-2"
                            >{{ errors.eventName }}</span
                          >
                        </div>

                        <div class="col-6">
                          <div class="form-group">
                            <label
                              class="ml-1"
                              for="state"
                              style="color: #616161; font-size: 14px"
                              ><b>Cantidad total *</b>
                              <i
                                class="fa fa-info-circle text-info ml-1"
                                style="font-size: 20px;"
                                aria-hidden="true"
                                data-bs-toggle="tooltip"
                                data-bs-placement="bottom"
                                title="Cantidad del producto."
                              ></i>
                            </label>
                            <input
                              :class="{ 'is-danger': errors.quantity }"
                              type="number"
                              v-model="form.quantity"
                              class="form-control"
                            />
                          </div>
                          <span
                            v-if="errors.quantity"
                            class="text-danger float-left small error-danger mb-2"
                            >{{ errors.quantity }}</span
                          >
                        </div>
                        <div class="col-6">
                          <div class="form-group">
                            <label
                              class="ml-1"
                              for="state"
                              style="color: #616161; font-size: 14px"
                              ><b>Disponibilidad *</b>
                              <i
                                class="fa fa-info-circle text-info ml-1"
                                style="font-size: 20px;"
                                aria-hidden="true"
                                data-bs-toggle="tooltip"
                                data-bs-placement="bottom"
                                title="La disponibilidad del producto, cada vez que un usuario reclame un regalo este valor va a disminuir."
                              ></i>
                            </label>
                            <input
                              :class="{ 'is-danger': errors.availability }"
                              type="number"
                              v-model="form.availability"
                              class="form-control"
                            />
                          </div>
                          <span
                            v-if="errors.availability"
                            class="text-danger float-left small error-danger mb-2"
                            >{{ errors.availability }}</span
                          >
                        </div>

                        <div class="col-6">
                          <div class="form-group">
                            <label
                              class="ml-1"
                              for="state"
                              style="color: #616161; font-size: 14px"
                              ><b>Fecha inicial *</b>
                              <i
                                class="fa fa-info-circle text-info ml-1"
                                style="font-size: 20px;"
                                aria-hidden="true"
                                data-bs-toggle="tooltip"
                                data-bs-placement="bottom"
                                title="Fecha incial del código promocional, el código se activará de forma automática."
                              ></i>
                            </label>
                            <input
                              :class="{ 'is-danger': errors.initDate }"
                              type="date"
                              v-model="form.initDate"
                              class="form-control"
                            />
                          </div>
                          <span
                            v-if="errors.initDate"
                            class="text-danger float-left small error-danger mb-2"
                            >{{ errors.initDate }}</span
                          >
                        </div>

                        <div class="col-6">
                          <div class="form-group">
                            <label
                              class="ml-1"
                              for="state"
                              style="color: #616161; font-size: 14px"
                              ><b>Fecha final *</b>
                              <i
                                class="fa fa-info-circle text-info ml-1"
                                style="font-size: 20px;"
                                aria-hidden="true"
                                data-bs-toggle="tooltip"
                                data-bs-placement="bottom"
                                title="Fecha final del código promocional, el código se inactivará de forma automática."
                              ></i>
                            </label>
                            <input
                              :class="{ 'is-danger': errors.finDate }"
                              type="date"
                              v-model="form.finDate"
                              class="form-control"
                            />
                          </div>
                          <span
                            v-if="errors.finDate"
                            class="text-danger float-left small error-danger mb-2"
                            >{{ errors.finDate }}</span
                          >
                        </div>

                        <div class="col-12">
                          <div class="form-group">
                            <label
                              class="ml-1"
                              for="state"
                              style="color: #616161; font-size: 14px"
                              ><b>Tipo de evento *</b>
                            </label>
                            <select
                              v-model="form.eventTypeId"
                              :class="{ 'is-danger': errors.eventTypeId }"
                              class="form-control"
                            >
                              <option value="null" disabled selected
                                >Seleccione</option
                              >
                              <option
                                v-for="(item, i) in listEventType"
                                :key="'td' + i"
                                :value="item.id"
                                class="color-option"
                                >{{ item.name }}
                              </option>
                            </select>
                          </div>
                          <span
                            v-if="errors.eventTypeId"
                            class="text-danger float-left small error-danger mb-2"
                            >{{ errors.eventTypeId }}</span
                          >
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-10 col-md-5 col-lg-4 col-xl-4 col-sm-10 mt-3">
                <button
                  data-dismiss="modal"
                  type="button"
                  class="btn btn-secondary btn-sm btn-block button-login"
                >
                  Cancelar
                </button>
              </div>
              <div
                class="col-10 col-md-5 col-lg-4 col-xl-4 col-sm-10 mt-3 mb-3"
              >
                <button
                  @click="save()"
                  type="button"
                  class="btn btn-danger btn-sm btn-block button-login"
                >
                  <template v-if="loading.history">
                    <span
                      class="spinner-border spinner-border-sm"
                      role="status"
                      aria-hidden="true"
                    ></span>
                    Cargando...
                  </template>
                  <template v-else>Aceptar</template>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal de editar bonos -->
    <div
      class="modal fade"
      id="modalPromoEdit"
      tabindex="-1"
      role="dialog"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered border-danger">
        <div class="modal-content modal-promotional">
          <div class="modal-body">
            <button
              type="button"
              data-dismiss="modal"
              aria-label="Close"
              class="close"
            >
              <i class="fa fa-times-circle text-danger" aria-hidden="true"></i>
            </button>
            <div class="mt-3 row justify-content-center">
              <div class="col-12 mb-3">
                <label style="color: #616161;">
                  <b> EDITAR EVENTO</b> </label
                ><br />
              </div>
              <!-- Estructura del formulario -->

              <div class="form-group">
                <div class="row" style="text-align: left">
                  <div class="col-12">
                    <div class="form-group">
                      <label
                        class="ml-1"
                        for="state"
                        style="color: #616161; font-size: 14px"
                        ><b>Nombre de producto *</b>
                      </label>
                      <input
                        :class="{ 'is-danger': errors.nameProduct }"
                        type="text"
                        v-model="formEdit.nameProduct"
                        class="form-control"
                      />
                    </div>
                    <span
                      v-if="errors.nameProduct"
                      class="text-danger float-left small error-danger mb-2"
                      >{{ errors.nameProduct }}</span
                    >
                  </div>

                  <div class="col-12">
                    <div class="form-group">
                      <label
                        class="ml-1"
                        for="state"
                        style="color: #616161; font-size: 14px"
                        ><b>Nombre del evento *</b>
                      </label>
                      <input
                        disabled
                        :class="{ 'is-danger': errors.eventName }"
                        type="text"
                        v-model="formEdit.eventName"
                        class="form-control"
                      />
                    </div>
                    <span
                      v-if="errors.eventName"
                      class="text-danger float-left small error-danger mb-2"
                      >{{ errors.eventName }}</span
                    >
                  </div>

                  <div class="col-6">
                    <div class="form-group">
                      <label
                        class="ml-1"
                        for="state"
                        style="color: #616161; font-size: 14px"
                        ><b>Cantidad *</b>
                        <i
                          class="fa fa-info-circle text-info ml-1"
                          style="font-size: 20px;"
                          aria-hidden="true"
                          data-bs-toggle="tooltip"
                          data-bs-placement="bottom"
                          title="  "
                        ></i>
                      </label>
                      <input
                        :class="{ 'is-danger': errors.quantity }"
                        type="number"
                        v-model="formEdit.quantity"
                        class="form-control"
                        placeholder="Escribe aquí los puntos"
                      />
                    </div>
                    <span
                      v-if="errors.quantity"
                      class="text-danger float-left small error-danger mb-2"
                      >{{ errors.quantity }}</span
                    >
                  </div>

                  <!-- <div class="col-6">
                          <div class="form-group">
                            <label
                              class="ml-1"
                              for="state"
                              style="color: #616161; font-size: 14px"
                              ><b>Disponibilidad *</b>
                              <i
                                class="fa fa-info-circle text-info ml-1"
                                style="font-size: 20px;"
                                aria-hidden="true"
                                data-bs-toggle="tooltip"
                                data-bs-placement="bottom"
                                title=" "
                              ></i>
                            </label>
                            <input
                              disabled
                              :class="{ 'is-danger': errors.availability }"
                              type="number"
                              v-model="formEdit.availability"
                              class="form-control"
                            />
                          </div>
                          <span
                            v-if="errors.availability"
                            class="text-danger float-left small error-danger mb-2"
                            >{{ errors.availability }}</span
                          >
                        </div> -->

                  <div class="col-6">
                    <div class="form-group">
                      <label
                        class="ml-1"
                        for="state"
                        style="color: #616161; font-size: 14px"
                        ><b>Fecha inicial *</b>
                        <i
                          class="fa fa-info-circle text-info ml-1"
                          style="font-size: 20px;"
                          aria-hidden="true"
                          data-bs-toggle="tooltip"
                          data-bs-placement="bottom"
                          title=" "
                        ></i>
                      </label>
                      <input
                        :class="{ 'is-danger': errors.initDate }"
                        type="date"
                        v-model="formEdit.initDate"
                        class="form-control"
                      />
                    </div>
                    <span
                      v-if="errors.initDate"
                      class="text-danger float-left small error-danger mb-2"
                      >{{ errors.initDate }}</span
                    >
                  </div>

                  <div class="col-6">
                    <div class="form-group">
                      <label
                        class="ml-1"
                        for="state"
                        style="color: #616161; font-size: 14px"
                        ><b>Fecha final *</b>
                        <i
                          class="fa fa-info-circle text-info ml-1"
                          style="font-size: 20px;"
                          aria-hidden="true"
                          data-bs-toggle="tooltip"
                          data-bs-placement="bottom"
                          title=" "
                        ></i>
                      </label>
                      <input
                        :class="{ 'is-danger': errors.finDate }"
                        type="date"
                        v-model="formEdit.finDate"
                        class="form-control"
                        placeholder="Escribe aquí la fecha final"
                      />
                    </div>
                    <span
                      v-if="errors.finDate"
                      class="text-danger float-left small error-danger mb-2"
                      >{{ errors.finDate }}</span
                    >
                  </div>

                  <div class="col-6">
                    <div class="form-group">
                      <label
                        class="ml-1"
                        for="state"
                        style="color: #616161; font-size: 14px"
                        ><b>Tipo de evento *</b>
                      </label>
                      <select
                        v-model="formEdit.eventTypeId"
                        :class="{ 'is-danger': errors.eventTypeId }"
                        class="form-control"
                      >
                        <option value="null" disabled selected
                          >Seleccione</option
                        >
                        <option
                          v-for="(item, i) in listEventType"
                          :key="'td' + i"
                          :value="item.id"
                          class="color-option"
                          >{{ item.name }}
                        </option>
                      </select>
                    </div>
                    <span
                      v-if="errors.eventTypeId"
                      class="text-danger float-left small error-danger mb-2"
                      >{{ errors.eventTypeId }}</span
                    >
                  </div>

                  <div class="col-6">
                    <div class="form-group">
                      <label
                        class="ml-1"
                        for="state"
                        style="color: #616161; font-size: 14px"
                        ><b>Estado *</b>
                      </label>
                      <select
                        v-model="formEdit.statusId"
                        :class="{ 'is-danger': errors.statusId }"
                        class="form-control"
                      >
                        <option value="null" disabled selected
                          >Seleccione</option
                        >
                        <option value="1">Activo</option>
                        <option value="2">Inactivo</option>
                        <option value="5" disabled>Pendiente</option>
                      </select>
                    </div>
                    <span
                      v-if="errors.statusId"
                      class="text-danger float-left small error-danger mb-2"
                      >{{ errors.statusId }}</span
                    >
                  </div>
                </div>
              </div>

              <div class="col-10 col-md-5 col-lg-4 col-xl-4 col-sm-10 mt-3">
                <button
                  data-dismiss="modal"
                  type="button"
                  class="btn btn-secondary btn-sm btn-block button-login"
                >
                  Cancelar
                </button>
              </div>
              <div
                class="col-10 col-md-5 col-lg-4 col-xl-4 col-sm-10 mt-3 mb-3"
              >
                <button
                  @click="updateSave()"
                  type="button"
                  class="btn btn-danger btn-sm btn-block button-login"
                >
                  <template v-if="loading.history">
                    <span
                      class="spinner-border spinner-border-sm"
                      role="status"
                      aria-hidden="true"
                    ></span>
                    Cargando...
                  </template>
                  <template v-else>Actualizar</template>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import $ from "jquery";
import vPagination from "vue-plain-pagination";
export default {
  components: { vPagination },
  data() {
    return {
      items: [],
      paginate: ["items"],
      page: 1,
      totalPages: 1,
      totaItems: null,
      currentPage: 1,
      listEventType: [],
      listStatus: [],
      form: {
        initDate: null,
        finDate: null,
        productName: "",
        eventName: "",
        quantity: 0,
        availability: 0,
        eventTypeId: null,
      },
      errors: {
        eventName: false,
        initDate: false,
        finDate: false,
        productName: false,
        quantity: false,
        availability: false,
        eventTypeId: false,
      },
      bootstrapPaginationClasses: {
        ul: "pagination",
        li: "page-item",
        liActive: "active",
        liDisable: "disabled",
        button: "page-link",
      },
      loading: {
        history: false,
      },
      formEdit: {
        initDate: null,
        finDate: null,
        productName: "",
        quantity: 0,
        availability: 0,
        eventTypeId: null,
        statusId: null,
      },
      currentFormE: null,
      codeEdit: "",
    };
  },
  watch: {
    "form.initDate": function(n) {
      if (n) {
        this.errors.initDate = false;
      } else {
        this.errors.initDate = "Este campo es requerido.";
      }
    },
    "form.quantity": function(n) {
      if (!n) {
        this.form.availability = this.form.quantity;
        this.errors.quantity = "Este campo es requerido.";
      } else if (n < 0) {
        this.errors.quantity = "El número la cantidad no puede ser negativa.";
      } else {
        this.errors.quantity = false;
        this.form.availability = this.form.quantity;
      }
    },
    "form.availability": function(n) {
      if (!n) {
        this.errors.availability = "Este campo es requerido.";
      } else if (n < 0) {
        this.errors.availability = "La disponibilidad no puede ser negativa.";
      } else {
        this.errors.availability = false;
      }
    },
    "form.initDate": function(n) {
      if (n) {
        this.errors.initDate = false;
      } else {
        this.errors.initDate = "Este campo es requerido.";
      }
    },
    "form.finDate": function(n) {
      if (n) {
        this.errors.initDate = false;
      } else {
        this.errors.initDate = "Este campo es requerido.";
      }
    },
    "form.eventTypeId": function(n) {
      if (n) {
        this.errors.eventTypeId = false;
      } else {
        this.errors.eventTypeId = "Este campo es requerido.";
      }
    },
  },
  methods: {
    clearForm() {
      this.form = {
        initDate: null,
        finDate: null,
        productName: "",
        quantity: 0,
        availability: 0,
        eventTypeId: null,
      };
      setTimeout(() => {
        this.errors = {
          eventName: false,
          initDate: false,
          finDate: false,
          productName: false,
          quantity: false,
          availability: false,
          eventTypeId: false,
        };
      }, 0);
    },
    irUser(data) {
      this.$router.push({ name: "listPromoUsers", params: { id: data.id } });
    },
    updateSave() {
      this.loading.history = true;
      var data = {};
      if (this.formEdit.nameProduct != this.currentFormE.productName) {
        data.productName = this.formEdit.nameProduct;
      }
      if (this.formEdit.initDate != this.currentFormE.init_date) {
        data.initDate = this.formEdit.initDate;
      }
      if (this.formEdit.finDate != this.currentFormE.fin_date) {
        data.finDate = this.formEdit.finDate;
      }
      if (this.formEdit.quantity != this.currentFormE.quantity) {
        data.quantity = this.formEdit.quantity;
      }
      if (this.formEdit.availability != this.currentFormE.availability) {
        data.availability = this.formEdit.availability;
      }
      if (this.formEdit.statusId != this.currentFormE.status_id) {
        data.statusId = this.formEdit.statusId;
      }
      if (this.formEdit.event_type_id != this.currentFormE.eventTypeId) {
        data.event_type_id = this.formEdit.event_type_id;
      }

      data.id = this.currentFormE.id;
      console.log(data);
      axios
        .put("superAdmin/events/update/" + data.id, data)
        .then((res) => {
          this.loading.history = false;
          if (res.data.cod == 0) {
            $("#modalPromoEdit").modal("hide");
            this.$swal({
              confirmButtonColor: "#dc3545",
              icon: "success",
              title: "Muy bien",
              text: res.data.message,
            });
            this.getList();
          }
        })
        .catch((error) => {
          this.loading.history = false;
          this.$swal({
            confirmButtonColor: "#dc3545",
            icon: "error",
            title: "Oops...",
            text: error.response.data.message,
          });
        });
    },
    openModalEdit(data) {
      console.log(data);
      this.currentFormE = data;
      this.formEdit.eventName = data.event_name;
      this.formEdit.nameProduct = data.product_name;
      this.formEdit.initDate = data.init_date;
      this.formEdit.finDate = data.fin_date;
      this.formEdit.quantity = data.quantity;
      this.formEdit.availability = data.availability;
      this.formEdit.eventTypeId = data.event_type_id;
      this.formEdit.statusId = data.status_id;
      this.formEdit.id = data.id;
      $("#modalPromoEdit").modal("show");
    },
    openModal() {
      $("#modalPromo").modal("show");
    },
    getListEvent() {
      axios
        .get("superAdmin/eventstype/list")
        .then((res) => {
          if (res.data.cod == 0) {
            this.listEventType = res.data.data;
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    save() {
      this.loading.history = true;
      axios
        .post("superAdmin/events/create", this.form)
        .then((res) => {
          this.loading.history = false;
          if (res.data.cod == 0) {
            $("#modalPromo").modal("hide");
            this.$swal({
              confirmButtonColor: "#dc3545",
              icon: "success",
              title: "Muy bien",
              text: res.data.message,
            });
            this.clearForm();
            this.getList();
          }
        })
        .catch((error) => {
          this.loading.history = false;
          this.$swal({
            confirmButtonColor: "#dc3545",
            icon: "error",
            title: "Oops...",
            text: error.response.data.message,
          });
        });
    },
    getList() {
      this.loading.history = true;
      axios
        .get("superAdmin/events/list/")
        .then((res) => {
          this.loading.history = false;
          if (res.data.cod == 0) {
            this.items = res.data.data;
          }
        })
        .catch((error) => {
          this.loading.history = false;
          this.$swal({
            confirmButtonColor: "#dc3545",
            icon: "error",
            title: "Oops...",
            text: error.response.data.message,
          });
        });
    },
  },
  mounted() {
    this.getListEvent();
    this.getList();
  },
};
</script>
<style>
.page-item.active .page-link {
  z-index: 3;
  color: #fff;
  background-color: #dc3545;
  border-color: #dc3545;
}
.page-link {
  border-radius: 100px;
  position: relative;
  display: block;
  padding: 0.5rem 0.75rem;
  margin-left: -1px;
  line-height: 1.25;
  color: #dc3545;
  background-color: #fff;
  border: 1px solid #dee2e6;
}

.page-link:hover {
  color: #000;
}
</style>
